<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <slot>
      <nx-bform-input  :required="required" v-model="form.contactAddress" />
      <nx-bform-input class="mt-2" v-model="form.contactAddress2" />
      <nx-bform-input class="mt-2" v-model="form.contactAddress3" />
      <nx-bform-input class="mt-2" v-model="form.contactAddress4" />
      <nx-bform-input class="mt-2" v-model="form.contactAddress5" />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";
import { assign } from "lodash";

export default {
  mixins: [FormGroupMixin],
  props:{address:{}},
  computed: {
    name() {
      return this.label || this.$t("contactAddress");
    }
  },
  data() {
    return {
      form: {
        contactAddress: '',
        contactAddress2: '',
        contactAddress3: '',
        contactAddress4: '',
        contactAddress5: ''
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        this.$emit("input", { ...form });
      }
    },
    address: {
      deep: true,
      immediate:true,
      handler(address) {
        console.log("address",address);
        assign(this.form, {
          contactAddress: address.contactAddress,
          contactAddress2: address.contactAddress2,
          contactAddress3: address.contactAddress3,
          contactAddress4: address.contactAddress4,
          contactAddress5: address.contactAddress5
        });
      }
    }
  }
};
</script>

<i18n src="@/locales/registration.locale.json" />
